import {
    Component,
    OnInit,
    ChangeDetectorRef,
    Input,
    ViewChild
} from '@angular/core';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { ProcessCategory } from '../ProcessCategory.model';
import { SortEvent, Table } from '../../shared/efaact-primeng.module';

@Component({
    selector: 'ef-help-desk',
    templateUrl: './help-desk.component.html',
    styleUrls: ['./help-desk.component.scss'],
    standalone: false
})
export class HelpDeskComponent implements OnInit {
    constructor(
        private log: LoggingService,
        private cdRef: ChangeDetectorRef
    ) {}
    public get processesCategories(): Array<ProcessCategory> {
        return this._processesCategories;
    }
    @Input() public set processesCategories(value: Array<ProcessCategory>) {
        this._processesCategories = value;
        this.updateRowGroupMetaData(value);
    }
    rowGroupMetadata: any;
    @ViewChild('dtGuide') guideTable: Table;

    private _processesCategories: Array<ProcessCategory>;
    hasDocumentation() {
        return this._processesCategories.some(x => x.UrlDocumentation);
    }
    hasTraining() {
        return this._processesCategories.some(x => x.UrlTraining);
    }
    hasDemo() {
        return this._processesCategories.some(x => x.UrlDemo);
    }

    ngOnInit() {}
    customSort($event: SortEvent) {
        this.log.verbose({
            type: 'IndirectRateRuleComponent:customSort',
            $event
        });
        $event.data.sort((a: ProcessCategory, b: ProcessCategory) => {
            const result = a.CategoryName.toLocaleLowerCase().localeCompare(
                b.CategoryName.toLocaleLowerCase()
            );
            return (
                (result === 0
                    ? a[$event.field]
                          .toLocaleLowerCase()
                          .localeCompare(b[$event.field].toLocaleLowerCase())
                    : result) * $event.order
            );
        });
    }
    onSort($event) {
        this.log.verbose({
            type: 'HelpDeskComponent:onSort',
            $event
        });
        setTimeout(() => {
            this.onUpdateRowGroupMetaData(
                this.guideTable.filteredValue || this.guideTable.value
            );
        }, 50);
    }
    onFilter($event) {
        this.log.verbose({
            type: 'HelpDeskComponent:onFilter',
            $event
        });
        this.onUpdateRowGroupMetaData($event.filteredValue);
    }

    onUpdateRowGroupMetaData(data) {
        this.updateRowGroupMetaData(data);
    }

    updateRowGroupMetaData(data) {
        this.rowGroupMetadata = {};
        if (data) {
            for (let i = 0; i < data.length; i++) {
                const rowData = data[i];
                const category = rowData.CategoryId;
                if (i === 0) {
                    this.rowGroupMetadata[category] = { index: 0, size: 1 };
                } else {
                    const previousRowData = data[i - 1];
                    const previousRowGroup = previousRowData.CategoryId;
                    if (category === previousRowGroup) {
                        this.rowGroupMetadata[category].size++;
                    } else {
                        this.rowGroupMetadata[category] = { index: i, size: 1 };
                    }
                }
            }
            this.log.verbose({
                type: 'HelpDeskComponent:updateRowGroupMetaData',
                data,
                rowGroupMetadata: this.rowGroupMetadata
            });
            this.cdRef.markForCheck();
        }
    }
}
